var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelegramWhite = function SvgTelegramWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_13",
    "data-name": "Exclusion 13",
    d: "M-3318,492a9.01,9.01,0,0,1-9-9,9.01,9.01,0,0,1,9-9,8.942,8.942,0,0,1,6.365,2.635A8.941,8.941,0,0,1-3309,483a8.941,8.941,0,0,1-2.635,6.365A8.942,8.942,0,0,1-3318,492Zm2.639-11.1c.056,0,.1.018.108.049s-.009.079-.062.127l-4.185,3.758,3.63,2.677a.782.782,0,0,0,.365.111c.228,0,.384-.171.452-.493l1.478-6.96a.7.7,0,0,0-.071-.6.4.4,0,0,0-.32-.151.578.578,0,0,0-.239.055l-8.67,3.344c-.3.12-.463.273-.456.42.006.122.134.229.35.293l2.227.7,5.153-3.247A.474.474,0,0,1-3315.362,480.9Z",
    transform: "translate(3327 -474)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegramWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram-white.c0fd7325.svg";
export { ForwardRef as ReactComponent };